export type SelectionStepKey = 'service' | 'location' | 'employee'

export const TITLE_BY_STEP: Record<SelectionStepKey, string> = {
  service: 'wb_select_services_title_label__html_text__',
  location: 'wb_select_locations_title_label__html_text__',
  employee: 'wb_select_employees_title_label__html_text__'
}

export const DATE_TITLE_KEY = 'wb_select_date_title_label__html_text__'

const STEP_BY_CONFIGURATION_KEY: Record<string, SelectionStepKey> = {
  [TITLE_BY_STEP.service]: 'service',
  [TITLE_BY_STEP.location]: 'location',
  [TITLE_BY_STEP.employee]: 'employee'
}

/**
 * The step the V3 preview should show. Editing a step's heading opens that
 * step, so the wording being typed is on screen instead of a state it never
 * appears in; everything else leaves the preview on the date step, which shows
 * the most of the widget. Employees can be switched off, and then their
 * heading has no step to open.
 */
export function previewStepForConfigurationKey (
  editedConfigurationKey: string | null,
  areEmployeesHidden: boolean
): SelectionStepKey | 'date' {
  const step = editedConfigurationKey ? STEP_BY_CONFIGURATION_KEY[editedConfigurationKey] : undefined

  if (!step || (step === 'employee' && areEmployeesHidden)) {
    return 'date'
  }

  return step
}

/**
 * The rail line for a step, taken from the heading the step itself shows. Only
 * the first paragraph goes in: the rail is a narrow column and anything the
 * tenant adds below the instruction is supporting copy written for the wide
 * panel. A <br> is Shift+Enter in TipTap - one thought, not a new paragraph -
 * so it stays a space and never truncates "Umów<br>wizytę". Tags become spaces
 * rather than vanishing, or the words around a break weld into one; what is
 * left goes through DOMParser only to decode entities, never running or
 * loading anything from it.
 *
 * Kept identical to stepPlaceholder in the client's CalendarV3.vue - the two
 * repos share no code, and a rail that disagrees with the published page is
 * worse than a duplicated ten lines.
 */
export function stepPlaceholderFromTitle (title: unknown): string {
  const markup = (typeof title === 'string' ? title : '')
    .replace(/<(script|style)[\s\S]*?<\/\1>/gi, ' ')
    .replace(/<\/(p|div|h[1-6]|li|blockquote)>/gi, '\n')
    .replace(/<\/?[^>]+(>|$)/g, ' ')

  return (new DOMParser().parseFromString(markup, 'text/html').body.textContent || '')
    .split('\n')
    .map((line: string) => line.replace(/\s+/g, ' ').trim())
    .find((line: string) => line.length > 0) || ''
}
